import React, {Component} from 'react';
import {TabBar, Toast,} from 'antd-mobile';
import {getSignature,txgetLocation} from '../../service/homeService';
import BMap from "BMap";
import "./style.less";
import connect from "react-redux/es/connect/connect";
import FileHome from "./FileHome";
import FileAdd from "./FileAdd";
import FileMy from "./FileMy";
let initTabPage = 'fileTab';
let gc;
@connect(
    state => ({userInfo: state.userInfo})
)
export default class MtLife extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedTab:'fileTab',
            hidden:false,
            selectedAddTab:"",
            address:"",
            point:"",
        };
    }
    componentDidMount() {
        getSignature(window.location.href.split('?')[0]).then((res)=>{
            if(res.data.code == '0000'){
                window.wx.config({
                    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                    appId:res.data.data.appId, // 必填，公众号的唯一标识
                    timestamp:res.data.data.timestamp , // 必填，生成签名的时间戳
                    nonceStr: res.data.data.nonceStr, // 必填，生成签名的随机串
                    signature:res.data.data.signature,// 必填，签名
                    jsApiList: [
                        'getLocation',
                    ] // 必填，需要使用的JS接口列表
                });
                window.wx.ready(()=>{
                    Toast.loading('正在定位',30);
                    this.getLocation();
                });
                window.wx.error((n)=>{
                    if(n.errMsg == 'config:invalid signature'){
                        window.location.reload()
                        // alert(JSON.stringify(n) + "签名失败");
                    }
                });
            }else{
                Toast.info(res.data.msg)
            }
        });
        console.log(this.state.selectedTab)
    }
    getLocation(){
        // let convertor = new BMap.Convertor();
        // gc = new BMap.Geocoder();
        const self = this;
        window.wx.getLocation({
            success: (r) =>{
                Toast.hide();
                let params = {
                    source: 1,
                    token: self.props.userInfo.token,
                    data:{location:r.latitude+','+r.longitude,get_poi:1}
                };
                txgetLocation(params).then((res)=>{
                    let result = res.data.data.result
                    console.log(result)
                    self.setState({
                        point: result.location,
                        address: result.address,
                    });
                })
                // convertor.translate([{lng: r.longitude,lat: r.latitude}], 1, 5, (data)=>{
                //     gc.getLocation(new BMap.Point(data.points[0].lng, data.points[0].lat), function (res) {
                //         console.log(res)
                //         self.setState({
                //             point: res.point,
                //             address: res.address,
                //         });
                //     });
                // })
            }
        })
    }
    tabChange(v){
        this.setState({selectedTab: v,});
        initTabPage = v;
    }
    fileBody(){
        if(this.state.selectedAddTab == 'addTab'){
            return <FileAdd {...this.props} clickBack={this.clickBack.bind(this)} address={this.state.address} point={this.state.point}/>
        }
        if(this.state.selectedTab == 'fileTab'){
            return <FileHome {...this.props} address={this.state.address} point={this.state.point}/>
        }
        if(this.state.selectedTab == 'myTab'){
            return <FileMy {...this.props}/>
        }
    }
    clickBack=()=>{
        // this.setState({selectedAddTab : ''})
        this.setState({hidden : false,selectedTab:this.state.selectedAddTab})
    };
    getBar(){
        // console.log(this.state.selectedTab)
        this.setState({selectedAddTab:this.state.selectedTab,selectedTab: 'addTab',hidden:true});
    }
    render(){
        return(
            <div className="mtLife" style={{position: 'fixed', height: '100%', width: '100%', top: 0}}>
                    <TabBar
                        unselectedTintColor="#000000"
                        tintColor="#FFCC00"
                        barTintColor="white"
                        hidden={this.state.hidden}
                        prerenderingSiblingsNumber={0}
                    >
                        <TabBar.Item
                            icon={<div />}
                            title={<div style={{fontSize:'17px',fontWeight:'bold',borderBottomWidth:'3px'}}>首页</div>}
                            // selectedTitle={<div style={{fontSize:'17px',fontWeight:'bold',borderBottom:'3px'}}>首页</div>}
                            key="Life"
                            selectedIcon={<div />}
                            selected={this.state.selectedTab === 'fileTab'}
                            onPress={() => {this.setState({selectedTab: 'fileTab',});}}
                            data-seed="logId"
                        >
                            <FileHome {...this.props} address={this.state.address} point={this.state.point}/>
                        </TabBar.Item>
                        <TabBar.Item
                            icon={
                                <div style={{
                                    width: '70px',
                                    height: '36px',
                                    background: 'url(http://download.ynsjj88.com/tj.png) center center /  70px 36px no-repeat' }}
                                />
                            }
                            key="addTab"
                            selected={this.state.selectedTab === 'addTab'}
                            onPress={() => this.getBar()}
                        >
                            <FileAdd {...this.props} clickBack={this.clickBack.bind(this)} address={this.state.address} point={this.state.point}/>
                        </TabBar.Item>
                        <TabBar.Item
                            icon={<div />}
                            selectedIcon={<div />}
                            // icon={{ uri: 'https://zos.alipayobjects.com/rmsportal/asJMfBrNqpMMlVpeInPQ.svg' }}
                            // selectedIcon={{ uri: 'https://zos.alipayobjects.com/rmsportal/gjpzzcrPMkhfEqgbYvmN.svg' }}
                            title={<div style={{fontSize:'17px',fontWeight:'bold'}}>我的</div>}
                            key="my"
                            selected={this.state.selectedTab === 'myTab'}
                            onPress={() => {this.setState({selectedTab: 'myTab',});}}
                        >
                            <FileMy {...this.props}/>
                        </TabBar.Item>
                    </TabBar>
                {/*{this.fileBody()}
                {
                    this.state.selectedAddTab == '' ? (
                        <div className="tabBar">
                            <div className={this.state.selectedTab == 'fileTab' ? "box boxColor":"box"}  onClick={()=>this.tabChange("fileTab")}>首页</div>
                            <div className="addFabu"  onClick={()=>this.setState({selectedAddTab: 'addTab',})}>+</div>
                            <div className={this.state.selectedTab == 'myTab' ? "box boxColor":"box"}  onClick={()=>this.tabChange("myTab")}>我的</div>
                        </div>
                    ):null
                }*/}

            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/MtLife/index.js